import { AxiosResponse } from 'axios';
import { instance as axios } from 'api/axios';

export class SMSService {
  static prefix = '/Message';

  public static async sendTestMessage(body: { phoneNumber: string; branchId: number }) {
    try {
      const url = `${SMSService.prefix}/Send/Test`;
      const response: AxiosResponse<any> = await axios.post(url, body);

      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  public static async getCauses() {
    try {
      const url = `${SMSService.prefix}/Cause`;
      const response: AxiosResponse<any> = await axios.get(url);

      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }
}
